// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axiosRestaurantInstance from "./restaurant/AxiosRestaurantInstance";
import { ORGANIZATION_API_PATHS } from "./constants/apiPaths";

// Firebase configuration - project: eats-business-fcm-dev
const firebaseConfig = {
  apiKey: "AIzaSyBezyclBFb9Z7Vd50U3Y0qxCXzlmDCf5Q8",
  authDomain: "eats-business-fcm-dev.firebaseapp.com",
  projectId: "eats-business-fcm-dev",
  storageBucket: "eats-business-fcm-dev.firebasestorage.app",
  messagingSenderId: "256680892096",
  appId: "1:256680892096:web:466fcea2f77eb60d0f7f25",
  measurementId: "G-905MJL19DE",
};

// Web Push certificate (VAPID) from Firebase Console >
// Project settings > Cloud Messaging > Web configuration > Key pair
const fbApiKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (error) {
  console.error("firebase-config: messaging init failed", error);
}

let serviceWorkerReady;
export const ensureMessagingServiceWorker = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return Promise.resolve(null);
  }
  if (!serviceWorkerReady) {
    serviceWorkerReady = navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .catch((error) => {
        console.error("firebase-config: service worker registration failed", error);
        return null;
      });
  }
  return serviceWorkerReady;
};

async function showBrowserNotification(title, options = {}) {
  if (typeof window === "undefined" || Notification.permission !== "granted") {
    return;
  }

  try {
    const registration =
      (await ensureMessagingServiceWorker()) ||
      (await navigator.serviceWorker.ready.catch(() => null));
    if (registration?.showNotification) {
      await registration.showNotification(title, {
        icon: "/business-os-logo.png",
        badge: "/business-os-logo.png",
        ...options,
      });
      return;
    }
  } catch (error) {
    console.warn("firebase-config: SW notification failed, falling back", error);
  }

  try {
    // Fallback (may be suppressed while the tab is focused in some browsers)
    new Notification(title, { icon: "/business-os-logo.png", ...options });
  } catch (error) {
    console.warn("firebase-config: Notification constructor failed", error);
  }
}

const sendTokenToServer = async (token) => {
  const response = await axiosRestaurantInstance.put(
    ORGANIZATION_API_PATHS.partnerFcmToken,
    { fcmToken: token }
  );
  console.log("[FCM] Partner API save response:", response?.data);
  return response?.data;
};

// Request permission and get the FCM token
export const requestPermissionAndSendToken = async () => {
  try {
    if (!fbApiKey) {
      console.error(
        "firebase-config: REACT_APP_FIREBASE_VAPID_KEY is missing. Generate a Web Push key pair in Firebase Console for eats-business-fcm-dev."
      );
      return null;
    }

    if (!localStorage.getItem("Token")) {
      console.warn("[FCM] Skipping token registration — no auth Token in localStorage");
      return null;
    }

    const registration = await ensureMessagingServiceWorker();

    const permission = await Notification.requestPermission();
    console.log("[FCM] Notification permission:", permission);
    if (permission !== "granted" || !messaging) {
      console.error("firebase-config.Notification permission denied");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: fbApiKey,
      ...(registration ? { serviceWorkerRegistration: registration } : {}),
    });
    if (!token) {
      console.error("firebase-config.No token received");
      return null;
    }

    console.log("[FCM] Device token:", token);
    const saveResult = await sendTokenToServer(token);
    console.log("[FCM] Token saved to partner API", saveResult);
    return token;
  } catch (error) {
    const status = error?.response?.status;
    const apiMessage = error?.response?.data?.message || error?.response?.data;
    console.error("[FCM] Error getting/saving FCM token:", {
      status,
      apiMessage,
      message: error?.message || error,
    });
    return null;
  }
};

// Set up onMessage listener to handle notifications while the app is in the foreground.
// Returns Firebase unsubscribe function.
export const setupForegroundNotification = (setNotification) => {
  if (!messaging) {
    console.log("firebase-config.setupForegroundNotification:messaging empty");
    return () => {};
  }

  return onMessage(messaging, (payload) => {
    console.log("firebase-config:Foreground message received. ", payload);

    const notificationTitle =
      payload.notification?.title || payload.data?.title || "Notification";
    const notificationBody =
      payload.notification?.body || payload.data?.body || "";

    showBrowserNotification(notificationTitle, {
      body: notificationBody,
      data: payload.data || {},
      requireInteraction: true,
    });

    if (typeof setNotification === "function") {
      setNotification({
        title: notificationTitle,
        body: notificationBody,
      });
    }
  });
};
